$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--1 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--2 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--3 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--4 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--5 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--6 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--7 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--8 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--9 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--10 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--11 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--12 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--13 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--14 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--15 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--16 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})




$('.main__map__balkon1 .map__main__row--1 .map__main__col--right--1 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--right--2 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--right--3 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--right--4 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--right--5 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--right--6 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--right--7 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--right--8 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--right--9 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--right--10 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--right--11 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--right--12 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--right--13 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--right--14 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--right--15 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--right--16 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})





$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--1 .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})

$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--2 .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})
$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--3 .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})
$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--4 .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})
$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--5 .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})
$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--6 .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})
$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--7 .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})
$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--8 .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})
$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--9 .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})
$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--10 .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})
$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--11 .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})
$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--12 .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})
$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--13 .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})
$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--14 .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})
$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--15 .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})
$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--16 .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})
$('.main__map__balkon1 .map__main__row--1 .map__main__col--left--1 .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})







$($('.main__map__balkon1 .map__main__row--1 .map__main__col--right--16 .seat-ctn .state').get().reverse()).each(function(index){
    $(this).css('transform', 'rotate('+ (index*1) +  'deg)')
})

